// Hideo - values for CSS url(…): quotes, brackets, spaces and backslashes are encoded, so the URL cannot break out
import { mediaUrl } from '../features/cloud/media'

const encode = (u: string): string => u.replace(/['"()\s\\]/g, c => '%' + c.charCodeAt(0).toString(16))

export const cssUrl = (u: string): string => `url("${encode(String(u))}")`

/** For url('…') in a style: a "media:<id>" reference (an image on Drive / on the device) becomes the address of the copy
 *  on this device (mediaUrl, which starts loading it when missing), then it is encoded like cssUrl. Ported from the
 *  legacy core/utils.js */
export const safeUrl = (u: string): string => encode(String(mediaUrl(u)))

/** style="…" of a box showing an image (thumbnails, avatars): background-image with safeUrl */
export const bgImage = (u: string): string => `background-image:url('${safeUrl(u)}')`
